module.exports = __webpack_public_path__ + "static/media/trie.536e53ea.png";